module.exports = __webpack_public_path__ + "static/media/iQumex-logo.14e8a9d5.jpg";